/**
 * `/` no host de produto.
 *
 * Até 2026-08-24 esta rota renderizava `modules/finance/HomePage`, que
 * bifurcava por estado de auth: anônimo via o gate de instalação, e o usuário
 * autenticado em desktop via `<DesktopUnderConstruction />` — uma tela "em
 * construção", ou seja, um beco sem saída.
 *
 * Com a SPA consumer deletada (o app Cuidari vive no Expo, servido em
 * `/m/*`), a raiz passa a servir SEMPRE o gate de instalação — exatamente o
 * que o anônimo já via. Para quem chega em `app.cuidari.com/` o CloudFront
 * já redireciona para o Expo antes de chegar aqui (ver
 * `cdk/frontend/frontend_construct.py`); esta rota é o que sobra para
 * `ariadne.francisquini.ai/` e para o preview local.
 */
import { InstallCTA } from '@/modules/install'

export function IndexPage() {
  return <InstallCTA webContinueHref="/login" />
}
